export const COMPANY_NAME = 'ParkApp Sp. z o.o.' as const;
export const COMPANY_ADDRES_LINE_1 = 'Człuchowska 13' as const;
export const COMPANY_ADDRES_LINE_2 = '85-808 Bydgoszcz' as const;

export const COMPANY_NIP = '9532802621' as const;
export const COMPANY_REGON = '528121812' as const;
export const COMPANY_KRS = '0001095079' as const;

export const IBAN = '85 1140 2004 0000 3502 8603 1994' as const;

export const SUPPORT_WEB = 'https://parkapp.pl' as const;
export const SUPPORT_FAQ_URL = 'https://parkapp.pl/faq/' as const;
export const SUPPORT_EMAIL = 'kontakt@parkapp.pl' as const;
export const SUPPORT_PHONE_NUMBER = '+48 518 518 800' as const;

export const REGULATIONS_URL = 'https://parkapp.pl/regulamin/' as const;
export const APP_TERMS_URL = 'https://parkapp.pl/regulamin/regulamin-aplikacji/' as const;
export const PARKING_TERMS_URL = 'https://parkapp.pl/regulamin/regulamin-parkowania/' as const;
export const PRIVACY_POLICY_URL = 'https://parkapp.pl/regulamin/polityka-prywatnosci/' as const;
export const CONTROLLER_RULES_URL = 'https://parkapp.pl/regulamin/kontroler-zasady/' as const;
export const CONTROLLER_STUDENT_AGREEMENT_URL =
  'https://parkapp.pl/regulamin/kontroler-umowa-uczniowie-studenci/' as const;
